import { render, staticRenderFns } from "./ProfilesList.vue?vue&type=template&id=cfc827c4&scoped=true&"
import script from "./ProfilesList.vue?vue&type=script&lang=js&"
export * from "./ProfilesList.vue?vue&type=script&lang=js&"
import style0 from "./ProfilesList.vue?vue&type=style&index=0&id=cfc827c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc827c4",
  null
  
)

export default component.exports